import { CommonState, ListParams, Pagination } from './common';
import { CreatedDates } from './client';

export enum CommentStatus {
  CANCELLED = 'cancelled',
  APPROVED = 'approved',
  HIDDEN = 'hidden',
}

export enum CommentComplaintReason {
  spam = 'spam',
  abuse = 'abuse',
  danger = 'danger',
  terror = 'terror',
  pics = 'pics',
}

export const COMMENT_COMPLAINT_REASONS_NAMES: Record<CommentComplaintReason, string> = {
  [CommentComplaintReason.spam]: 'Спам или ложная информация',
  [CommentComplaintReason.abuse]: 'Оскорбления или дискриминация',
  [CommentComplaintReason.danger]: 'Вредные или опасные действия',
  [CommentComplaintReason.terror]: 'Пропаганда терроризма',
  [CommentComplaintReason.pics]: 'Нецензурные изображения',
} as const;

export type CommentImage = {
  ban: boolean;
  comment_id: number;
  created_at: string;
  id: number;
  name: string;
  updated_at: string;
};

export type Comment = {
  client?: {
    id: number;
    name: string;
    mute: boolean;
    avatar: string;
  };
  id: number;
  group_id: number;
  user_id: number;
  client_id: number;
  parent_id: number;
  status: CommentStatus;
  title: string;
  text: string;
  created_at: string;
  updated_at: string;
  uname: boolean;
  images: CommentImage[];
  pics: CommentImage[];
  replies: Comment[];
  fixed: boolean;
  rating_me: number;
};

export type CommentList = {
  data?: Comment[];
  meta?: Pagination;
};

export type CommentListParams = Omit<ListParams, 'order_by' | 'order'> &
  CreatedDates & {
    status?: [CommentStatus];
    scan?: string;
    sort?: 'asc' | 'desc';
    sort_by?: string;
    isReview: boolean;
  };

export type CommentGroup = {
  active: boolean;
  created_at: string;
  id: number;
  type: string;
  type_id: number;
  type_name: string;
  type_name_course?: string;
  updated_at: string;
};

export type CommentState = CommonState & {
  comments: Comment[];
  commentsReview: Comment[];
  meta: Pagination | null;
  metaReview: Pagination | null;
  commentListParams: CommentListParams;
  commentReviewListParams: CommentListParams;
  comment: Comment | null;
  commentGroups: CommentGroup[];
  filtersListParams: CommentListParams;
  filtersReviewListParams: CommentListParams;
  filtersErrors: CreatedDates;
  filtersReviewErrors: CreatedDates;
};

export type ParamsCommentCreate = {
  text: string;
  title?: string;
  parent_id?: number;
  group_id?: number;
};

export type ParamsCommentChange = {
  id: number;
  text: string;
  title?: string;
  status: string;
  uname?: boolean;
  parent_id: number | null;
};

export interface ApproveCommentRequest {
  ids: number[];
  status: string;
  isReview: boolean;
}

export interface DeleteCommentRequest {
  ids: number[];
  isReview: boolean;
}
